module.exports = __webpack_public_path__ + "img/四川天府新区干塘幼儿园.4f4e006a.jpg";